import React, { Children } from 'react';
import { FadeIn } from './FadeIn';
export function AboutSection() {
  return <section id="about" className="py-24 md:py-32 bg-cream relative" data-id="element-13">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-15">
          {/* Image Column */}
          <FadeIn direction="right" data-id="element-16">
            <div className="relative" data-id="element-17">
              {/* Decorative background element */}
              <div className="absolute -inset-4 bg-gold/10 transform rotate-3 rounded-sm" data-id="element-18" />

              <div className="relative aspect-[3/4] bg-charcoal rounded-sm overflow-hidden border border-gold/20 shadow-2xl" data-id="element-19">
                <img src="https://cdn.magicpatterns.com/uploads/wsZabRN8ymxvHzMJMUaiEG/Apostlephillipsbookcoversession15of30-683x1024.jpg" alt="Apostle Akintunde Phillips" className="w-full h-full object-cover" data-id="element-20" />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/40 to-transparent" data-id="element-21" />
              </div>
            </div>
          </FadeIn>

          {/* Text Column */}
          <FadeIn direction="left" delay={0.2} data-id="element-22">
            <div data-id="element-23">
              <div className="flex items-center gap-4 mb-6" data-id="element-24">
                <div className="h-[1px] w-12 bg-gold" data-id="element-25" />
                <span className="text-gold font-semibold tracking-[0.2em] text-sm uppercase" data-id="element-26">
                  About
                </span>
              </div>

              <h2 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-charcoal mb-8 leading-tight" data-id="element-27">
                Apostle Akintunde <br data-id="element-28" /> Phillips
              </h2>

              <div className="space-y-6 text-charcoal/70 font-inter text-lg leading-relaxed" data-id="element-29">
                <p data-id="element-30">
                  Apostle Akintunde Phillips, a reflection of God's grace and
                  unconditional love, is the Senior Pastor of the
                  non-denominational "Grace of God Ministries." A man of great
                  honor and integrity, set out to empower and disciple the
                  Children of God with a teachable spirit who desire to learn.
                </p>
                <p data-id="element-31">
                  His ministry is characterized by a deep passion for restoring
                  the love of God in the hearts of men, delivering life-changing
                  truth to lost, shattered, and desperate souls, and raising
                  leaders through discipleship and practical leadership
                  training.
                </p>
                <p data-id="element-32">
                  Through Apostle Phillips Ministries, he continues to reconnect
                  and re-establish people back to God through fervent prayers,
                  uncompromising Bible teaching, and a heart devoted to seeing
                  lives transformed by the power of the Gospel.
                </p>
              </div>

              <div className="mt-10 flex items-center gap-4" data-id="element-33">
                <span className="text-gold font-playfair font-semibold text-lg italic" data-id="element-34">
                  Senior Pastor, Grace of God Ministries
                </span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}